import { render } from "./ChatMessages.vue?vue&type=template&id=f6dd2eb2&scoped=true"
import script from "./ChatMessages.vue?vue&type=script&lang=js"
export * from "./ChatMessages.vue?vue&type=script&lang=js"

import "./ChatMessages.vue?vue&type=style&index=0&id=f6dd2eb2&scoped=true&lang=css"

import exportComponent from "/Users/jluan/code/whatgpt/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6dd2eb2"]])

export default __exports__